<template>
  <div class="index-chart" aria-hidden="true"></div>
</template>

<script>
  export default {
    // name : "Chart",
    props: {
      data: {
        required: true,
      },
      xCategories: {
        required: true,
      },
      yCategories: {
        required: true,
      },
      isPrint: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        // target: undefined
      };
    },
    mounted() {
      this.buildChart();
    },

    methods: {
      buildChart() {
        let chartWidth = 500;
        let chartOptions = {
          credits: {
            enabled: false,
          },
          chart: {
            type: 'heatmap',
            plotBorderWidth: 1,
            width: chartWidth,
          },

          title: {
            text: '',
          },

          xAxis: {
            categories: this.xCategories,
          },

          yAxis: {
            categories: this.yCategories,
            title: null,
          },

          colorAxis: {
            min: 0,
            minColor: '#FFFFFF',
            maxColor: Highcharts.getOptions().colors[0],
            labels: {
              enabled: false,
            },
          },

          legend: {
            enabled: false,
          },

          tooltip: {
            enabled: false,
          },
          series: [
            {
              name: 'Sales per employee',
              borderWidth: 1,
              data: this.data,
              dataLabels: {
                enabled: false,
              },
            },
          ],
        };
        this.target = new Highcharts.chart(this.$el, chartOptions);
      },
    },

    beforeDestroy: function () {
      this.target.destroy();
    },
  };
</script>
<style scoped lang="css">
  .index-chart {
    height: 300px;
    margin-left: auto;
    margin-right: auto;
  }
</style>
